export function isEmpty(array) {
  return !array?.length;
}
